export default "__VITE_ASSET__9wGvE3cl__"